import { useMutation } from '@apollo/client';

import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

import GetContractDetailsQuery from '@/graphql/contracts/getContractDetails.query.gql';
import { notificationService } from '@/services/notification/notification.client';

import UpdateContractCustomerMutation from '@/graphql/contracts/updateContractCustomer.mutation.gql';
import { UpdateContractCustomerInputType } from '@/graphql/contracts/_generated_/contracts';
import { GetContractDetails, GetContractDetailsVariables } from
  '@/graphql/contracts/_generated_/getContractDetails.query';
import { UpdateContractCustomer, UpdateContractCustomerVariables } from
  '@/graphql/contracts/_generated_/updateContractCustomer.mutation';


export default function useUpdateContractCustomer() {
  const { contractId }: { contractId: UUID } = useParams();
  const [_updateContractCustomer, { loading }] = useMutation<
  UpdateContractCustomer, UpdateContractCustomerVariables>(
    UpdateContractCustomerMutation,
    {
      client: apolloClientContracts,
      update: (_, { data }) => {
        if (!data?.updateContractCustomer) return;

        apolloClientContracts.writeQuery<GetContractDetails, GetContractDetailsVariables>({
          query: GetContractDetailsQuery,
          variables: { contractId },
          data: {
            contract: data.updateContractCustomer
          }
        });
      },
      onError: (err) => {
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        });
      },
      onCompleted: () => notificationService.open({
        title: 'Update Contract Customer',
        text: 'Contract customer successfully updated',
        type: 'success'
      }),
    },
  );

  const updateContractCustomer = async (contractCustomerData: UpdateContractCustomerInputType) => {
    return (await _updateContractCustomer({
      variables: {
        input: contractCustomerData
      },
      onQueryUpdated(observableQuery) {
        return observableQuery.refetch();
      },
    }))?.data ?? null;
  };

  return {
    updateContractCustomer,
    isLoadingUpdateContractCustomer: loading
  } as const;
}
